export const ProjectInfoButtonInject: any[] = [];
